import React, { useState } from 'react';
import useUserData from '../hooks/useUserData';
import ProductList from './ProductList';
import MyProductList from './MyProduct';
import BackWithBreadcrumbAppbar from '../components/BackWithBreadcrumbAppbar';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';

const Container = styled('div')({
  position: 'relative',
  minHeight: '100vh',
  backgroundColor: theme => theme.palette.background.default,
});

const TabsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  position: 'sticky',
  top: 80,
  zIndex: 1000,
}));

const TabButton = styled(motion.button)(({ theme, active }) => ({
  padding: '1rem 2rem',
  border: 'none',
  backgroundColor: 'transparent',
  fontSize: '1rem',
  fontWeight: 500,
  color: active ? theme.palette.primary.main : '#666',
  position: 'relative',
  cursor: 'pointer',
  transition: 'color 0.3s ease',
  '&:hover': {
    color: theme.palette.primary.dark,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '2px',
    backgroundColor: theme.palette.primary.main,
    transform: active ? 'scaleX(1)' : 'scaleX(0)',
    transformOrigin: 'center',
    transition: 'transform 0.3s ease',
  },
}));

const TabContent = styled(motion.div)({
  padding: '0rem',
  maxWidth: '1200px',
  margin: '0 auto',
});

const tabVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

const ProductPage = () => {
  const { data, refetch } = useUserData();
  const [activeTab, setActiveTab] = useState('products');
  const { t } = useTranslation();

  let userdata = data?.me;
  if (typeof data?.me === 'string') {
    userdata = JSON.parse(data?.me);
  }

  const user = userdata;

  if (user?.role === 'exhibitors') {
    return (
      <Container>
        <BackWithBreadcrumbAppbar
          links={[{ label: t('dashboard'), href: '/' }]}
          currentPage={t('products')}
        />
        
        <TabsContainer>
          <TabButton
            active={activeTab === 'products'}
            onClick={() => setActiveTab('products')}
            whileHover={{ scale: 1.05 }}
          >
            {t('products')}
          </TabButton>
          <TabButton
            active={activeTab === 'my-products'}
            onClick={() => setActiveTab('my-products')}
            whileHover={{ scale: 1.05 }}
          >
            {t('myProducts')}
          </TabButton>
        </TabsContainer>

        <AnimatePresence mode='wait'>
          <TabContent
            key={activeTab}
            variants={tabVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            {activeTab === 'products' ? (
              <ProductList />
            ) : (
              <MyProductList user={user} />
            )}
          </TabContent>
        </AnimatePresence>
      </Container>
    );
  }

  return (
    <Container>
      <BackWithBreadcrumbAppbar
          links={[{ label: t('dashboard'), href: '/' }]}
          currentPage={t('products')}
        />
      <ProductList />
    </Container>
  );
};

export default ProductPage;